import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=6f4655b6&scoped=true"
import script from "./SectionList.vue?vue&type=script&lang=js"
export * from "./SectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4655b6",
  null
  
)

export default component.exports